<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <span>
                    <input class="searchInputText" type="text" placeholder="広告クラスタ名 / 商品名 / 商品コード / URL"
                        v-model="searchKeyword" @keydown="enterSearch">
                </span>
                <span>
                    <a class="btn searchBtn" @click="searchItem">検索</a>
                </span>
            </div>
            <div class="headerRightMenu">
                <span>
                    <a class="btn addBtn" @click="showModal('CreateAdCluster')">広告クラスタ 新規登録</a>
                </span>
            </div>
        </div>

        <ul class="list">
            <li class="info" v-for="(item, i) in items" :key="i">
                <div class="infoLeft">
                    <p class="name">{{ item.ad_cluster_name }}</p>
                    <p>
                        <span>URL: </span>
                        <a :href="item.url" target="_blank">{{ item.url }}</a>
                    </p>
                    <p>
                        <span>広告媒体: </span>
                        <span v-if="item.linkedAds.length == 0">
                            広告が登録されていません。
                        </span>
                        <span v-else class="registeredAds">
                            <table>
                                <tr>
                                    <td class="registeredByAdMediaAd">
                                        <span v-for="(adMedia, j) in Object.keys(item.linkedAds)" :key="j">
                                            {{ adMedia }}
                                            <span v-if="j != Object.keys(item.linkedAds).length - 1">,</span>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </span>
                    </p>
                </div>
                <div class="infoRight">
                    <p class="btn editBtn" style="margin-right: 30px;" @click="showModal('Prorate', item.id)">按分率登録</p>
                    <p class="btn editBtn" @click="showModal('LinkAdClusterAndAds', item.id)">広告登録</p>
                    <p class="btn deleteBtn" @click="openDeleteModal(item.id)">削除</p>
                </div>
            </li>
        </ul>
        <div class="listFooter">
            <paginate :page-count="getPageCount" :click-handler="clickCallback" :force-page="currentPage"
                :prev-text="'←'" :next-text="'→'" :container-class="'pagination'" :page-class="'page-item'"
                style="display: flex;"></paginate>
        </div>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>

        <modal name="CreateAdCluster" :draggable="false" :resizable="false" :clickToClose="closeStatus" width="80%"
            height="330px" @closed="modalClosed(modalName)">
            <CreateAdCluster @modalClosed="modalClosed('CreateAdCluster')" @updateAdClusters="updateAdClusters" />
        </modal>
        <modal name="Prorate" :draggable="false" :resizable="false" width="90%" height="99%"
            @closed="modalClosed(modalName)">
            <Prorate @modalClosed="modalClosed('Prorate')" @updated="fetchAdCluster" :adClusterId=this.clickedItemId />
        </modal>
        <modal name="LinkAdClusterAndAds" :draggable="false" :resizable="false" width="90%" height="99%"
            @closed="modalClosed(modalName)">
            <LinkAdClusterAndAds @modalClosed="modalClosed('LinkAdClusterAndAds')" @updated="fetchAdCluster"
                :adClusterId=this.clickedItemId />
        </modal>
        <modal name="AdClusterDeleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
            <DeleteModal @canceled="closeDeleteModal" @deleted="deleteAdCluster" />
        </modal>
    </div>
</template>

<script>
import CreateAdCluster from './CreateAdCluster.vue';
import Prorate from './Prorate.vue';
import LinkAdClusterAndAds from './LinkAdClusterAndAds.vue';
import DeleteModal from '../components/DeleteModal.vue';

export default {
    components: {
        CreateAdCluster,
        Prorate,
        LinkAdClusterAndAds,
        DeleteModal,
    },
    data() {
        return {
            isSearchedProduct: false,
            clickedItemId: "",
            currentPage: 1,
            getPageCount: 0,
            modalName: "",
            perPage: 9,
            searchKeyword: "",
            statusMessage: "",
            items: [],
            resultItems: [],
            deleteId: null
        }
    },
    mounted: function () {
        this.fetchAdCluster();
    },
    methods: {
        fetchAdCluster() {
            this.$store.dispatch("loading", true);
            const searchWordParam = this.isSearchedProduct ? this.searchKeyword : '';
            this.axios.get("/api/adClusters?page=" + this.currentPage, { params: { searchWords: searchWordParam } })
                .then((res) => {
                    this.items = res.data.ad_clusters;
                    this.getPageCount = Number(res.data.last_Page);
                    this.$store.dispatch("loading", false);
                }).catch(() => {
                })
        },
        clickCallback: function (pageNum) {
            this.currentPage = Number(pageNum);
            this.fetchAdCluster();
        },
        // モーダルを閉じる
        modalClosed(modalName) {
            this.modalShow = false
            this.$modal.hide(modalName)
        },
        // モーダルを表示する
        showModal(modalName, itemId) {
            this.clickedItemId = itemId
            this.modalShow = true
            this.$modal.show(modalName)
        },
        // 文字列検索
        searchItem: function () {
            this.currentPage = 1;
            this.axios.get("/api/adClusters?page=1", { params: { searchWords: this.searchKeyword } })
                .then((res) => {
                    this.isSearchedProduct = (this.searchKeyword === '') ? false : true;
                    this.items = res.data.ad_clusters;
                    this.getPageCount = Number(res.data.last_Page);
                    this.resultItems = this.items
                }).catch(() => {
                })
        },
        // エンターキーが押された時に文字列検索を実行
        enterSearch: function (e) {
            if (e.keyCode == 13) {
                this.searchItem();
            }
        },
        deleteAdCluster() {
            var url = "/api/adClusters/" + this.deleteId;
            this.$store.dispatch("loading", true);
            this.axios.delete(url).then(() => {
                this.$emit('updated');

                this.modalShow = false;
                this.$modal.hide("AdClusterDeleteModal");
                this.fetchAdCluster();
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        openDeleteModal(id) {
            this.deleteId = id;
            this.$modal.show('AdClusterDeleteModal');
        },
        closeDeleteModal() {
            this.deleteId = null;
            this.$modal.hide('AdClusterDeleteModal');
        },
        // 子コンポーネントからemitされたitemを格納。
        updateAdClusters: function (updateAdClusters) {
            this.currentPage = 1;
            this.isSearchedProduct = false;
            this.items = updateAdClusters.ad_clusters;
            this.getPageCount = Number(updateAdClusters.last_Page);
        },
    },
    computed: {
        // 背景をクリックでモーダルを閉じるステータス
        closeStatus: function () {
            if (!this.$store.state.loading && !this.$store.state.added) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 360px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                #unregistered
                    display: none
                .unregisteredCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #unregistered:checked + .unregisteredCheckBox::after
                    opacity: 1
        .headerRightMenu
            flex: 1 0 auto
            span
                display: inline-block
                text-align: left
                vertical-align: middle
                .addBtn, .adsetUpdateBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 170px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
    .list
        background: $whiteColor
        font-size: 1.2rem
        height: 75%
        margin: 10px 140px 0 140px
        overflow-y: scroll
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                width: 85%
                p
                    margin: 5px 0 10px 20px
                    font-size: 1.4rem
                .name
                    font-weight: 700
                .registeredAds
                    display: inline-block
                    vertical-align: top
                    tr
                        &:first-child
                            .registeredByAdMediaAd
                                padding-top: 0px
                        .registeredByAdMediaAd
                            border-bottom: 1px solid rgba(2, 173, 144, 0.25)
                            padding: 4px 0 3px 5px
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
                .deleteBtn
                    width: 120px
                    color: #ff5252
                    background-color: #fff
                    border: 1px solid #ff5252
                    &:hover
                        color: #fff
                        background-color: #ff5252
                .editBtn
                    border: 1px solid $mainColor
                    padding: 8px
                    margin-bottom: 8px 
                    width: 120px
                    &:hover
                        border: 1px solid $mainColor
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        .pageDisp
            font-size: 1.3rem
            line-height: 42px
            right: 15px
            position: absolute
            top: 50%
    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 0 0 0 10px
            .headerLeftMenu
                .searchInputText
                    width: 150px !important
            .headerRightMenu
                margin-top: 10px
        .list
            margin: 10px 0 0
            .info
                display: block
                .infoLeft
                    margin-top: 10px
</style>
